import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function RekycThankYouPage() {
  return (
    <Box sx={{ m: 4 }}>
      <Typography variant="h4" gutterBottom>
        Thank you for providing us with the updated information.
      </Typography>
      <Typography variant="body1" gutterBottom>
        We will review the information and if all is in order, this exercise is complete and this
        page will be disabled. Otherwise, we will be in touch. There’s nothing more for you to do in
        the meantime!
      </Typography>
    </Box>
  );
}

export default RekycThankYouPage;
